import products from './products'

export default {
  products
}



// WEBPACK FOOTER //
// ./src/vuex/api/services/index.js